<template>
  <v-row>
    <v-col cols="12">
      <page-header
        icon="mdi-cog"
        :title="$t('settings')"
        :subtitle="$t('manage_restaurant_settings')"
      />
    </v-col>

    <global-confirm-box ref="confirmBox"></global-confirm-box>
    <v-col cols="12">
      <p class="heading-medium text-center">
        {{ $t("contracts") }}
      </p>
    </v-col>
    <v-col cols="12" sm="12">
      <!-- NOVA VREMENSKA PODESAVANJA-->
      <v-row>
        <v-col v-if="!settings.new_time_changes" cols="12" class="d-flex text-body-2">
          <v-switch
            @click="switchTimeStatus('new')"
            v-model="settings.new_time_changes"
            inset
          ></v-switch>
          <p class="heading-small">
            {{ $t("new_time_changes") }}
          </p>
        </v-col>
        <v-col cols="12">
          <p class="heading-small text-center">
            {{ $t("order_dead_line") }}
          </p>
        </v-col>
      </v-row>
      <v-col cols="12" v-if="settings.new_time_changes" class="mb-8">
        <v-row class="time-settings-row border-bottom">
          <v-col cols="12" sm="2" class="py-2 text-center">
            <label class="primary-bg-light" for="">{{ $t("monday") }}</label>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :title="$t('day_before_limit')"
              :label="$t('day_before_limit')"
              type="number"
              v-model="settings.days.monday.day_before_limit"
            >
            </text-field>
          </v-col>
          <v-col cols="12" sm="5" class="primary-bg-light py-2">
            <v-row>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_from_hour"
                  item-value="val"
                  v-model="settings.days.monday.time.time_hour"
                  :label="$t('starting_from_h')"
                >
                </autocomplete>
              </v-col>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_to_min"
                  item-value="val"
                  v-model="settings.days.monday.time.time_minut"
                  :label="$t('up_to_min')"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :title="$t('day_after_limit')"
              :label="$t('day_after_limit')"
              type="number"
              v-model="settings.days.monday.day_after_limit"
            >
            </text-field>
          </v-col>
        </v-row>
        <v-row class="time-settings-row border-bottom">
          <v-col cols="12" sm="2" class="py-2 text-center">
            <label class="primary-bg-light" for="">{{ $t("tuesday") }}</label>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_before_limit')"
              type="number"
              v-model="settings.days.tuesday.day_before_limit"
            >
            </text-field>
          </v-col>
          <v-col cols="12" sm="5" class="primary-bg-light py-2">
            <v-row>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_from_hour"
                  item-value="val"
                  v-model="settings.days.tuesday.time.time_hour"
                  :label="$t('starting_from_h')"
                >
                </autocomplete>
              </v-col>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_to_min"
                  item-value="val"
                  v-model="settings.days.tuesday.time.time_minut"
                  :label="$t('up_to_min')"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_after_limit')"
              type="number"
              v-model="settings.days.tuesday.day_after_limit"
            >
            </text-field>
          </v-col>
        </v-row>
        <v-row
          style="
            border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            display: flex;
            align-items: center;
            margin-bottom: 0;
          "
        >
          <v-col cols="12" sm="2" class="py-2 text-center">
            <label class="primary-bg-light" for="">{{ $t("wednesday") }}</label>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_before_limit')"
              type="number"
              v-model="settings.days.wednesday.day_before_limit"
            />
          </v-col>
          <v-col cols="12" sm="5" class="primary-bg-light py-2">
            <v-row>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_from_hour"
                  item-value="val"
                  v-model="settings.days.wednesday.time.time_hour"
                  :label="$t('starting_from_h')"
                >
                </autocomplete>
              </v-col>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_to_min"
                  item-value="val"
                  v-model="settings.days.wednesday.time.time_minut"
                  :label="$t('up_to_min')"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_after_limit')"
              type="number"
              v-model="settings.days.wednesday.day_after_limit"
            >
            </text-field>
          </v-col>
        </v-row>
        <v-row
          class="time-settings-row"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); margin-bottom: 0"
        >
          <v-col cols="12" sm="2" class="py-2 text-center">
            <label class="primary-bg-light" for="">{{ $t("thursday") }}</label>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_before_limit')"
              type="number"
              v-model="settings.days.thursday.day_before_limit"
            >
            </text-field>
          </v-col>
          <v-col cols="12" sm="5" class="primary-bg-light py-2">
            <v-row>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_from_hour"
                  item-value="val"
                  v-model="settings.days.thursday.time.time_hour"
                  :label="$t('starting_from_h')"
                >
                </autocomplete>
              </v-col>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_to_min"
                  item-value="val"
                  v-model="settings.days.thursday.time.time_minut"
                  :label="$t('up_to_min')"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_after_limit')"
              type="number"
              v-model="settings.days.thursday.day_after_limit"
            >
            </text-field>
          </v-col>
        </v-row>
        <v-row
          class="time-settings-row"
          style="
            border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            display: flex;
            align-items: center;
            margin-bottom: 0;
          "
        >
          <v-col cols="12" sm="2" class="py-2 text-center">
            <label class="primary-bg-light" for="">{{ $t("friday") }}</label>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_before_limit')"
              type="number"
              v-model="settings.days.friday.day_before_limit"
            >
            </text-field>
          </v-col>
          <v-col cols="12" sm="5" class="primary-bg-light py-2">
            <v-row>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_from_hour"
                  item-value="val"
                  v-model="settings.days.friday.time.time_hour"
                  :label="$t('starting_from_h')"
                >
                </autocomplete>
              </v-col>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_to_min"
                  item-value="val"
                  v-model="settings.days.friday.time.time_minut"
                  :label="$t('up_to_min')"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_after_limit')"
              type="number"
              v-model="settings.days.friday.day_after_limit"
            >
            </text-field>
          </v-col>
        </v-row>
        <v-row
          class="time-settings-row"
          style="
            border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            display: flex;
            align-items: center;
            margin-bottom: 0;
          "
        >
          <v-col cols="12" sm="2" class="py-2 text-center">
            <label class="primary-bg-light" for="">{{ $t("saturday") }}</label>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_before_limit')"
              type="number"
              v-model="settings.days.saturday.day_before_limit"
            >
            </text-field>
          </v-col>
          <v-col cols="12" sm="5" class="primary-bg-light py-2">
            <v-row>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_from_hour"
                  item-value="val"
                  v-model="settings.days.saturday.time.time_hour"
                  :label="$t('starting_from_h')"
                >
                </autocomplete>
              </v-col>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_to_min"
                  item-value="val"
                  v-model="settings.days.saturday.time.time_minut"
                  :label="$t('up_to_min')"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_after_limit')"
              type="number"
              v-model="settings.days.saturday.day_after_limit"
            >
            </text-field>
          </v-col>
        </v-row>
        <v-row
          class="time-settings-row"
          style="
            border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            display: flex;
            align-items: center;
            margin-bottom: 0;
          "
        >
          <v-col cols="12" sm="2" class="py-2 text-center">
            <label class="primary-bg-light" for="">{{ $t("sunday") }}</label>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_before_limit')"
              type="number"
              v-model="settings.days.sunday.day_before_limit"
            >
            </text-field>
          </v-col>
          <v-col cols="12" sm="5" class="primary-bg-light py-2">
            <v-row>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_from_hour"
                  item-value="val"
                  v-model="settings.days.sunday.time.time_hour"
                  :label="$t('starting_from_h')"
                >
                </autocomplete>
              </v-col>
              <v-col cols="6">
                <autocomplete
                  :items="delivery_to_min"
                  item-value="val"
                  v-model="settings.days.sunday.time.time_minut"
                  :label="$t('up_to_min')"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="2" class="py-2">
            <text-field
              :label="$t('day_after_limit')"
              type="number"
              v-model="settings.days.sunday.day_after_limit"
            >
            </text-field>
          </v-col>
        </v-row>
      </v-col>
      <!-- KRAJ VREMENSKA PODESAVANJA-->
      <v-row>
        <v-col cols="12" sm="9">
          <v-switch
            v-model="settings.no_time_limit"
            inset
            :label="$t('no_time_limit')"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="9">
          <v-switch
            v-model="settings.confirm_delivery"
            inset
            :label="$t('automatic_delivery_no_confirm')"
          ></v-switch>
        </v-col>
        <v-col cols="12" sm="3">
          <text-field
            v-model="settings.timer"
            :label="$t('next_delivery_time_sec')"
          ></text-field>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="12">
      <v-switch
        v-model="settings.izvestaj"
        inset
        :label="$t('delivery_report_available_for_users')"
      ></v-switch>
    </v-col>
    <v-col cols="12" sm="12">
      <v-switch
        v-model="settings.worker"
        inset
        :label="$t('enable_meal_pickup_another_branch')"
      ></v-switch>
    </v-col>
    <v-col cols="12" sm="12">
      <v-switch
        v-model="settings.can_reserve"
        inset
        :label="$t('enable_spare_meal_belated_user')"
      ></v-switch>
    </v-col>

    <v-col cols="12">
      <p class="heading-medium text-center">
        {{ $t("guest_settings") }}
      </p>
    </v-col>
    <!--  Narucivanje bez ugovora PODESAVANJE ZA GOSTA-->

    <v-row class="okolo">
      <v-col lg="6" sm="12" class="mb-0 pb-0">
        <v-switch
          class="mb-n5"
          v-model="settings.lice_bez_ugovora"
          inset
          :label="
            $t('ordering_persons_without_contract') +
            ' (' +
            $t('consumption_options') +
            ')'
          "
        ></v-switch>
      </v-col>
    </v-row>
    <section v-if="settings.lice_bez_ugovora">
      <v-row class="okolo">
        <v-col lg="4" sm="12" class="mb-0 pb-0">
          <v-switch
            class="mb-n5"
            v-model="settings.guest.meal_in_restaurant"
            inset
            :label="$t('meal_in_restaurant')"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row class="okolo">
        <v-col lg="4" sm="12" class="mb-0 pb-0">
          <v-switch
            v-model="settings.guest.personal_takeover"
            inset
            :label="$t('personal_takeover')"
          ></v-switch>
        </v-col>
      </v-row>
      <v-col class="mt-3" cols="12" sm="12">
        <v-row class="okolo mt-5">
          <v-switch
            id="restoran-obavlja-isporuku"
            @click="setDelivery()"
            v-model="settings.guest.restoran_delivery"
            inset
            :label="$t('restaurant_delivers')"
          ></v-switch>
          <div v-if="settings.guest.restoran_delivery" class="delivery-description">
            <v-row class="" v-if="settings.guest.restoran_delivery">
              <v-col cols="12" sm="6">
                <text-field
                  v-model="settings.guest.delivery_price"
                  :label="$t('delivery_price')"
                ></text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <text-field
                  v-model="settings.guest.minimal_price"
                  type="number"
                  :label="$t('minimal_price')"
                ></text-field>
              </v-col>
            </v-row>
          </div>
        </v-row>
      </v-col>
      <v-col class="mt-n8" cols="12" sm="12">
        <v-row class="okolo align-center">
          <v-switch
            id="slanje-postom"
            @click="setDelivery()"
            v-model="settings.guest.post_delivery"
            inset
            :label="$t('post_delivery')"
          ></v-switch>
          <div v-if="settings.guest.post_delivery" class="post-delivery-description">
            <v-row>
              <v-col cols="12" sm="6">
                <text-field
                  v-model="settings.guest.post_price"
                  :label="$t('delivery_price_post')"
                ></text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <text-field
                  v-model="settings.guest.post_minimal_price"
                  :label="$t('minimal_price_post')"
                ></text-field>
              </v-col>
            </v-row>
          </div>
        </v-row>
      </v-col>
      <v-col class="mt-n8" cols="12" sm="9">
        <text-area
          class="mt-0"
          v-model="settings.guest.post_description"
          inset
          :label="$t('post_description')"
        ></text-area>
      </v-col>
      <v-row class="okolo">
        <v-col lg="4" sm="12">
          <p class="mb-0 subtitle-1 font-weight-normal">
            {{ $t("delivery_time_set") }}
            <span
              v-if="settings.delivery_from && settings.delivery_from1"
              class="text-tiny font-weight-bold"
              >({{ settings.delivery_from + ":" + settings.delivery_to }} -
              {{ settings.delivery_from1 + ":" + settings.delivery_to1 }})</span
            >
          </p>
        </v-col>
        <v-col lg="4" sm="12">
          <v-row>
            <v-col lg="6" sm="12">
              <autocomplete
                :items="delivery_from"
                item-value="val"
                v-model="settings.delivery_from_hour"
                :label="$t('starting_from_h')"
              />
            </v-col>
            <v-col lg="6" sm="12">
              <autocomplete
                :items="delivery_to"
                item-value="val"
                v-model="settings.delivery_from_min"
                :label="$t('starting_from_min')"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4" sm="12">
          <v-row>
            <v-col lg="6" sm="12">
              <autocomplete
                :items="delivery_from"
                item-value="val"
                v-model="settings.delivery_to_hour"
                :label="$t('up_to_h')"
              />
            </v-col>
            <v-col lg="6" sm="12">
              <autocomplete
                :items="delivery_to"
                item-value="val"
                v-model="settings.delivery_to_min"
                :label="$t('up_to_min')"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-col cols="12" sm="12">
        <v-checkbox
          :label="$t('customer_can_set_delivery_time')"
          type="number"
          outlined
          v-bind:false-value="0"
          v-bind:true-value="1"
          v-model.number="settings.check_delivery_time"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="8" class="d-flex align-center">
        <v-row>
          <v-col cols="12" sm="5">
            <p class="subtitle-1 mb-0">{{ $t("cancel_time") }}</p>
          </v-col>
          <v-col cols="12" sm="2">
            <text-field
              :label="$t('up_to_min1')"
              type="number"
              v-model="settings.guest.guest_cancel_order_time"
            >
            </text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="8">
        <v-row>
          <v-col cols="12" sm="5">
            <p class="subtitle-1 mb-0">{{ $t("max_days_to_order_daily_menu") }}</p>
          </v-col>
          <v-col cols="12" sm="4">
            <autocomplete
              :items="broj_dana_bez_menija"
              item-value="val"
              v-model="settings.guest.dani_bez_menija"
              :label="$t('selected_days_count')"
            />
          </v-col>
        </v-row>
      </v-col>
      <!-- VREMENSKA PODESAVANJA GOST-->
      <v-col cols="12" class="d-flex text-body-2">
        <v-switch v-model="settings.guest_day.new_time_changes" inset></v-switch>
        <p class="heading-small">
          {{ $t("new_time_changes") }}
        </p>
      </v-col>
      <v-col cols="12" v-if="settings.guest_day.new_time_changes"> </v-col>
      <v-col cols="12" v-if="settings.guest_day.new_time_changes" class="mb-8">
        <v-row
          v-for="(day, index) in weekDays"
          :key="day.key"
          class="day-settings-row"
          :id="index === 0 ? 'vreme-za-narudzbe' : null"
          style="
            border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            display: flex;
            align-items: center;
            margin-bottom: 0;
          "
        >
          <v-col class="text-center py-0" sm="1" cols="12">
            <label class="primary-bg-light" for="">{{ day.label }}</label>
          </v-col>
          <v-col
            class="text-center position-relative grey lighten-4 rounded py-0"
            sm="4"
            cols="12"
          >
            <div
              style="
                text-align: center;
                font-size: 13px;
                font-weight: 700;
                padding-top: 10px;
              "
            >
              {{ $t("time_for_deliver") }}
            </div>
            <v-row>
              <v-col lg="6" sm="12">
                <v-row>
                  <v-col lg="6" sm="12">
                    <autocomplete
                      :items="delivery_from"
                      item-value="val"
                      v-model="settings.guest_day[day.key].working_hours.delivery_from"
                      :label="$t('starting_from_h')"
                    />
                  </v-col>
                  <v-col lg="6" sm="12">
                    <autocomplete
                      :items="delivery_to"
                      item-value="val"
                      v-model="settings.guest_day[day.key].working_hours.delivery_to"
                      :label="$t('starting_from_min')"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col lg="6" sm="12">
                <v-row>
                  <v-col lg="6" sm="12">
                    <autocomplete
                      :items="delivery_from"
                      item-value="val"
                      v-model="settings.guest_day[day.key].working_hours.delivery_from1"
                      :label="$t('up_to_h')"
                    />
                  </v-col>
                  <v-col lg="6" sm="12">
                    <autocomplete
                      :items="delivery_to"
                      item-value="val"
                      v-model="settings.guest_day[day.key].working_hours.delivery_to1"
                      :label="$t('up_to_min')"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="position-relative py-0" sm="2" cols="12">
            <div
              style="
                text-align: center;
                font-size: 11px;
                font-weight: 700;
                padding-bottom: 9px;
              "
            >
              {{ $t("first_day_of_order") }}
            </div>
            <v-row class="ml-3">
              <text-field
                :label="$t('day_before_limit')"
                type="number"
                v-model="settings.guest_day[day.key].day_before_limit"
              >
              </text-field>
            </v-row>
          </v-col>
          <v-col class="py-0 text-center" style="max-width: 2.3% !important"><</v-col>
          <v-col class="primary-bg-light px-8" sm="2" cols="12">
            <div
              style="
                text-align: center;
                font-size: 12px;
                font-weight: 700;
                padding-bottom: 10px;
              "
            >
              {{ $t("limit") }}
            </div>

            <v-row class="pb-2">
              <v-col>
                <autocomplete
                  :items="delivery_from_hour"
                  item-value="val"
                  v-model="settings.guest_day[day.key].time.time_hour"
                  :label="$t('starting_from_h1')"
                >
                </autocomplete>
              </v-col>
              <v-col>
                <autocomplete
                  :items="delivery_to_min"
                  item-value="val"
                  v-model="settings.guest_day[day.key].time.time_minut"
                  :label="$t('up_to_min1')"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col class="py-0 text-center" style="max-width: 2.3% !important">></v-col>
          <v-col class="position-relative py-0" sm="2" cols="12">
            <div
              style="
                text-align: center;
                font-size: 12px;
                font-weight: 700;
                padding-bottom: 10px;
              "
            >
              {{ $t("first_day_of_order1") }}
            </div>
            <v-row class="ml-0">
              <text-field
                :label="$t('day_after_limit')"
                type="number"
                v-model="settings.guest_day[day.key].day_after_limit"
              >
              </text-field>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- VREMENSKA PODESAVANJA GOST-->
      <v-col cols="12" class="d-flex text-body-2">
        <!--      Dozvoljeno restoranu da moze da vrsi uklucivanje/iskljucivanje narudzbi-->
        <v-switch
          v-model="settings.can_order_off"
          inset
          :label="$t('restaurant_order_off')"
        ></v-switch>
        <!--      Restoran moze/ne moze da prima narudzbe-->
        <v-switch
          style="margin-left: 40px"
          v-model="settings.receiving_orders"
          inset
          :label="$t('receiving_orders')"
        ></v-switch>
      </v-col>
    </section>
    <v-col lg="12" sm="12" class="mb-0 pb-0">
      <v-col col="12" sm="2" class="">
        <autocomplete
          :items="valuta"
          item-value="val"
          v-model="settings.price"
          :label="$t('select_currency')"
        />
      </v-col>
    </v-col>
    <!--    KOMENTARI-->
    <v-col cols="12" sm="9" class="pr-16 mb-10">
      <h3>{{ $t("comments") }}</h3>
      <v-row class="okolo">
        <v-col lg="12" sm="12" class="mb-0 pb-0">
          <v-switch
            class="mb-n5"
            v-model="settings.comments_guest"
            inset
            :label="$t('comments_guest')"
          ></v-switch>
        </v-col>
        <v-col lg="12" sm="12" class="mb-0 pb-0">
          <v-switch
            class="mb-n5"
            v-model="settings.comments_restaurant"
            inset
            :label="$t('comments_restaurant')"
          ></v-switch>
        </v-col>
      </v-row>
    </v-col>
    <!-- KRAJ Narucivanje bez ugovora-->
    <!-- JEZICI -->
    <v-col cols="12" sm="9" class="pr-16">
      <p class="heading-small">
        {{ $t("language_settings") }}
      </p>
      <autocomplete
        :label="$t('choose_language')"
        v-model="settings.language"
        :items="[
          { code: 'sr', name: 'Српски - ћирилица' },
          { code: 'sr-lat', name: 'Srpski - Latinica' },
          { code: 'rs', name: 'Ћирилица' },
          { code: 'rs-lat', name: 'Latinica' },
          { code: 'hr', name: 'Hrvatski' },
          { code: 'bs', name: 'Bosanski' },
          { code: 'en', name: 'English' },
          { code: 'mk', name: 'Makedonski' },
          { code: 'si', name: 'Slovenščina' },
          { code: 'ru', name: 'Русский (Ruski)' },
          { code: 'es', name: 'Español (Španski)' },
          { code: 'it', name: 'Italiano (Italijanski)' },
          { code: 'fr', name: 'Français (Francuski)' },
          { code: 'de', name: 'Deutsch (Nemački)' },
          { code: 'zh', name: '中文 (Kineski)' },
          { code: 'tr', name: 'Türkçe (Turski)' },
          { code: 'uz', name: 'Oʻzbekcha (Uzbečki)' },
        ]"
        hide-details
        multiple
        item-value="code"
        item-text="name"
      />
    </v-col>
    <!-- IJEKAVICA EKAVICA -->
    <v-col cols="12" sm="10">
      <v-row>
        <v-col cols="12" sm="12" class="mb-0 pb-0 mt-6">
          <p class="heading-extra-small">{{ $t("enter_language") }}:</p>
        </v-col>
        <v-col cols="12" sm="3" class="mt-0 pt-0">
          <v-radio-group @change="changeLang()" v-model="alphabet" row>
            <v-radio :label="translate($t('lat'))" value="lat"></v-radio>
            <v-radio label="Ћир" value="cir"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row> </v-row>
    </v-col>

    <v-col cols="12">
      <p class="heading-large text-center">
        {{ $t("design_web") }}
      </p>
    </v-col>
    <v-col cols="12">
      <p class="heading-medium">
        {{ $t("web") }}
      </p>
    </v-col>
    <v-col sm="12" lg="9">
      <v-row>
        <v-col>
          <v-col class="pb-10 pb-3">
            <v-row class="image-width" align="center" justify="center">
              <v-img
                :src="
                  conf.apiUrlBase +
                  '/gallery/' +
                  $store.state.restaurant.id +
                  '/medium/' +
                  settings.logo
                "
                v-if="settings.logo"
                contain
              >
                <v-row justify="center" align="center" class="fill-height">
                  <primary-button
                    color="error"
                    @click="
                      changeLogo = 1;
                      gallery = true;
                    "
                  >
                    {{ $t("logo") }}
                  </primary-button>
                  <remove-button
                    style="position: absolute; top: 85px"
                    @click="removeImageConfirm('logo')"
                  ></remove-button>
                </v-row>
              </v-img>
              <v-btn
                v-else
                class="ma-2"
                outlined
                color="primary"
                small
                @click="
                  changeLogo = 1;
                  gallery = true;
                "
              >
                {{ $t("logo") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-col>
        <v-col>
          <v-col class="pb-10 mb-3">
            <v-row class="image-width" align="center" justify="center">
              <v-img
                :src="
                  conf.apiUrlBase +
                  '/gallery/' +
                  $store.state.restaurant.id +
                  '/medium/' +
                  settings.header
                "
                v-if="settings.header"
                contain
              >
                <v-row justify="center" align="center" class="fill-height">
                  <primary-button
                    color="error"
                    @click="
                      changeHeader = 1;
                      gallery = true;
                    "
                  >
                    {{ $t("header") }}
                  </primary-button>
                  <remove-button
                    style="position: absolute; top: 85px"
                    @click="removeImageConfirm('header')"
                  ></remove-button>
                </v-row>
              </v-img>
              <v-btn
                v-else
                class="ma-2"
                outlined
                color="primary"
                small
                @click="
                  changeHeader = 1;
                  gallery = true;
                "
              >
                {{ $t("header") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-col>
        <v-col>
          <v-col class="pb-10 mb-3">
            <v-row align="center" class="image-width" justify="center">
              <v-img
                :src="
                  conf.apiUrlBase +
                  '/gallery/' +
                  $store.state.restaurant.id +
                  '/medium/' +
                  settings.restoran_image
                "
                v-if="settings.restoran_image"
                contain
              >
                <v-row justify="center" align="center" class="fill-height">
                  <primary-button
                    color="error"
                    @click="
                      changeRestoran = 1;
                      gallery = true;
                    "
                  >
                    {{ $t("restaurant") }}
                  </primary-button>
                  <remove-button
                    style="position: absolute; top: 85px"
                    @click="removeImageConfirm('restoran_image')"
                  ></remove-button>
                </v-row>
              </v-img>
              <v-btn
                v-else
                class="ma-2"
                outlined
                color="primary"
                small
                @click="
                  changeRestoran = 1;
                  gallery = true;
                "
              >
                {{ $t("restaurant") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-col>
      </v-row>
    </v-col>
    <!--  Дизајн мобилне апп-->
    <v-col cols="12">
      <p class="heading-medium">
        {{ $t("mobile_app_design") }}
      </p>
    </v-col>
    <v-row class="pl-4 mb-6">
      <v-col sm="12" lg="3">
        <v-col cols="12" class="pb-4">
          <v-row class="image-width" align="center" justify="center">
            <v-img
              :src="
                conf.apiUrlBase +
                '/gallery/' +
                $store.state.restaurant.id +
                '/medium/' +
                settings.logo_mob_header
              "
              v-if="settings.logo_mob_header"
              contain
            >
              <v-row
                justify="center"
                align="center"
                class="position-relative fill-height"
              >
                <primary-button
                  color="error"
                  @click="
                    changeLogoMob = 1;
                    gallery = true;
                  "
                >
                  {{ $t("banner_header") }}
                </primary-button>
                <remove-button
                  style="position: absolute; top: 85px"
                  @click="removeImageConfirm('logo_mob_header')"
                ></remove-button>
              </v-row>
            </v-img>
            <v-btn
              v-else
              class="ma-2"
              outlined
              color="primary"
              small
              @click="
                changeLogoMob = 1;
                gallery = true;
              "
            >
              {{ $t("banner_header") }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col class="pl-0">
          <v-col cols="10 mt-3" class="pb-0">
            <text-field
              :label="$t('header_banner_link')"
              v-model="settings.mob.baner_link_header"
              class="pt-0"
            >
            </text-field>
          </v-col>
        </v-col>
      </v-col>
      <v-col sm="12" lg="3">
        <v-col cols="12" class="pb-4 position-relative">
          <v-row class="image-width" align="center" justify="center">
            <v-img
              :src="
                conf.apiUrlBase +
                '/gallery/' +
                $store.state.restaurant.id +
                '/medium/' +
                settings.logo_mob_footer
              "
              v-if="settings.logo_mob_footer"
              contain
            >
              <v-row justify="center" align="center" class="fill-height">
                <primary-button
                  color="error"
                  @click="
                    changeLogoMobFooter = 1;
                    gallery = true;
                  "
                >
                  {{ $t("banner_footer") }}
                </primary-button>
                <remove-button
                  style="position: absolute; top: 85px"
                  @click="removeImageConfirm('logo_mob_footer')"
                ></remove-button>
              </v-row>
            </v-img>
            <v-btn
              v-else
              class="ma-2"
              outlined
              color="primary"
              small
              @click="
                changeLogoMobFooter = 1;
                gallery = true;
              "
            >
              {{ $t("banner_footer") }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col class="pl-0">
          <v-col cols="10 mt-3">
            <text-field
              :label="$t('footer_banner_link')"
              v-model="settings.mob.baner_link_footer"
              class="pt-0"
            >
            </text-field>
          </v-col>
        </v-col>
      </v-col>
      <v-col sm="12" lg="3">
        <v-col cols="12" class="pb-4">
          <v-row class="image-width" align="center" justify="center">
            <v-img
              :src="
                conf.apiUrlBase +
                '/gallery/' +
                $store.state.restaurant.id +
                '/medium/' +
                settings.logo_mob_restoran
              "
              v-if="settings.logo_mob_restoran"
              contain
            >
              <v-row justify="center" align="center" class="fill-height">
                <primary-button
                  color="error"
                  @click="
                    changeLogoMobRestoran = 1;
                    gallery = true;
                  "
                >
                  {{ $t("restaurant") }}
                </primary-button>
                <remove-button
                  style="position: absolute; top: 85px"
                  @click="removeImageConfirm('logo_mob_restoran')"
                ></remove-button>
              </v-row>
            </v-img>
            <v-btn
              v-else
              title="Slika u listi restorana"
              class="ma-2"
              outlined
              color="primary"
              small
              @click="
                changeLogoMobRestoran = 1;
                gallery = true;
              "
            >
              {{ $t("restaurant") }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col class="pl-0">
          <v-col cols="10 mt-3">
            <text-field
              :label="$t('restaurant_banner_link')"
              v-model="settings.mob.baner_link_restoran"
              class="pt-0"
            >
            </text-field>
          </v-col>
        </v-col>
      </v-col>
      <!-- BOJE MOB -->
      <v-row class="mt-1 okolo"> </v-row>
    </v-row>
    <v-col cols="12">
      <p class="heading-medium">
        {{ $t("links") }}
      </p>
    </v-col>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="3">
          <text-field label="Facebook" v-model="settings.facebook"> </text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <text-field label="Instagram" v-model="settings.instagram"> </text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <text-field label="Twitter" v-model="settings.twitter"> </text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <text-field label="Linkedin" v-model="settings.linkedin"> </text-field>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="3">
          <text-field label="Google Play" v-model="settings.google"> </text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <text-field label="Apple Store" v-model="settings.apple"> </text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <text-field label="Huawei Store" v-model="settings.huawei"> </text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <text-field :label="$t('web_application')" v-model="settings.webapp">
          </text-field>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <primary-button block @click="save">
        {{ $t("record") }}
      </primary-button>
    </v-col>
    <global-dialog-card
      v-model="gallery"
      :title="$t('select_image')"
      :max-width="1000"
      hide-actions
    >
      <text-field
        v-model="searchImage"
        @input="filterImage"
        :label="$t('search')"
        prepend-inner-icon="mdi-magnify"
      />
      <v-row>
        <v-col
          v-for="image in imagesFilter"
          :key="image.id"
          class="d-flex child-flex"
          cols="12"
          sm="6"
          md="4"
          xl="3"
        >
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-img
                :src="
                  conf.apiUrlBase +
                  '/gallery/' +
                  $store.state.restaurant.id +
                  '/medium/' +
                  image.name
                "
                @click="selectImage(image)"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
            <v-col cols="12" class="pt-0 text-center">
              <div>{{ image.name | imageName }}</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </global-dialog-card>
  </v-row>
</template>

<script>
import conf from "@/config";
import moment from "moment";
import menuService from "@/services/menu";
import restaurantService from "@/services/restaurant";
import hasSnackbar from "@/mixins/hasSnackbar";
import PageHeader from "@/components/global/PageHeader.vue";

export default {
  components: {
    PageHeader,
  },
  mixins: [hasSnackbar],
  data() {
    return {
      conf: conf,
      txt_lang: "",
      changeLogo: 0,
      changeLogoMob: 0,
      changeLogoMobFooter: 0,
      changeLogoMobRestoran: 0,
      changeHeader: 0,
      changeRestoran: 0,
      imagesFilter: "",
      valuta: [
        { text: "KM", val: "KM" },
        { text: "EUR", val: "EUR" },
        { text: "DIN", val: "DIN" },
      ],
      broj_dana_bez_menija: [
        { text: "0", val: 0 },
        { text: "1", val: 1 },
        { text: "2", val: 2 },
        { text: "3", val: 3 },
        { text: "4", val: 4 },
        { text: "5", val: 5 },
        { text: "6", val: 6 },
        { text: "7", val: 7 },
        { text: "8", val: 8 },
        { text: "9", val: 9 },
        { text: "10", val: 10 },
        { text: "11", val: 11 },
        { text: "12", val: 12 },
        { text: "13", val: 13 },
        { text: "14", val: 14 },
        { text: "15", val: 15 },
      ],
      delivery_from: [
        { text: "00", val: "00" },
        { text: "01", val: "01" },
        { text: "02", val: "02" },
        { text: "03", val: "03" },
        { text: "04", val: "04" },
        { text: "05", val: "05" },
        { text: "06", val: "06" },
        { text: "07", val: "07" },
        { text: "08", val: "08" },
        { text: "09", val: "09" },
        { text: "10", val: "10" },
        { text: "11", val: "11" },
        { text: "12", val: "12" },
        { text: "13", val: "13" },
        { text: "14", val: "14" },
        { text: "15", val: "15" },
        { text: "16", val: "16" },
        { text: "17", val: "17" },
        { text: "18", val: "18" },
        { text: "19", val: "19" },
        { text: "20", val: "20" },
        { text: "21", val: "21" },
        { text: "22", val: "22" },
        { text: "23", val: "23" },
        { text: "24", val: "24" },
      ],
      delivery_to: [
        { text: "00", val: "00" },
        { text: "15", val: "15" },
        { text: "30", val: "30" },
        { text: "45", val: "45" },
      ],
      delivery_from_hour: [
        { text: "00", val: 0 },
        { text: "01", val: 1 },
        { text: "02", val: 2 },
        { text: "03", val: 3 },
        { text: "04", val: 4 },
        { text: "05", val: 5 },
        { text: "06", val: 6 },
        { text: "07", val: 7 },
        { text: "08", val: 8 },
        { text: "09", val: 9 },
        { text: "10", val: 10 },
        { text: "11", val: 11 },
        { text: "12", val: 12 },
        { text: "13", val: 13 },
        { text: "14", val: 14 },
        { text: "15", val: 15 },
        { text: "16", val: 16 },
        { text: "17", val: 17 },
        { text: "18", val: 18 },
        { text: "19", val: 19 },
        { text: "20", val: 20 },
        { text: "21", val: 21 },
        { text: "22", val: 22 },
        { text: "23", val: 23 },
        { text: "24", val: 24 },
      ],
      delivery_to_min: [
        { text: "00", val: 0 },
        { text: "15", val: 15 },
        { text: "30", val: 30 },
        { text: "45", val: 45 },
        { text: "59", val: 59 },
      ],
      settings: {
        comments_guest: false,
        comments_restaurant: false,
        check_delivery_time: 1,
        days: {
          monday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
          },
          tuesday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
          },
          wednesday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
          },
          thursday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
          },
          friday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
          },
          saturday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
          },
          sunday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
          },
          day: {
            monday: "",
            tuesday: "",
            wednesday: "",
            thursday: "",
            friday: "",
            saturday: "",
            sunday: "",
          },
        },
        google: "https://play.google.com/store/apps/details?id=rs.bitlab.ordera",
        apple: "https://apps.apple.com/app/id1664273786",
        huawei: "https://appgallery.huawei.com/app/C107593211",
        old_time_changes: false,
        new_time_changes: true,
        no_time_limit: false,
        receiving_orders: true,
        can_order_off: false,
        order_before_hours: "",
        language: [],
        non_working_days: [],
        guest_day: {
          new_time_changes: true,
          monday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
              delivery_from: "",
              delivery_to: "",
              delivery_from1: "",
              delivery_to1: "",
            },
          },
          tuesday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
              delivery_from: "",
              delivery_to: "",
              delivery_from1: "",
              delivery_to1: "",
            },
          },
          wednesday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
              delivery_from: "",
              delivery_to: "",
              delivery_from1: "",
              delivery_to1: "",
            },
          },
          thursday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
              delivery_from: "",
              delivery_to: "",
              delivery_from1: "",
              delivery_to1: "",
            },
          },
          friday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
              delivery_from: "",
              delivery_to: "",
              delivery_from1: "",
              delivery_to1: "",
            },
          },
          saturday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
              delivery_from: "",
              delivery_to: "",
              delivery_from1: "",
              delivery_to1: "",
            },
          },
          sunday: {
            time: {
              time_hour: "",
              time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
              delivery_from: "",
              delivery_to: "",
              delivery_from1: "",
              delivery_to1: "",
            },
          },
          day: {
            monday: "",
            tuesday: "",
            wednesday: "",
            thursday: "",
            friday: "",
            saturday: "",
            sunday: "",
          },
        },
        guest: {
          guest_cancel_order_time: "",
          post_description: "",
          rok_dana: false,
          meal_in_restaurant: false,
          order_before: "",
          rok_sati: false,
          dan: "",
          broj_sati: "",
          restoran_delivery: false,
          post_delivery: false,
          personal_takeover: false,
          minimal_price: 0,
          post_minimal_price: 0,
          post_price: 0,
          delivery_price: "",
          dani_bez_menija: 1,
        },
        lice_bez_ugovora: false,
        topbar: {
          background: "#FB6D3B",
        },
        footer: {
          background: "#FB6D3B",
        },
        mob: {
          primary: "#FB6D3B",
          text_toolbar_color: "#FB6D3B",
          text_color: "#FB6D3B",
          button_color: "#FB6D3B",
          baner_link_header: null,
          baner_link_footer: null,
          baner_link_restoran: null,
        },
        mobColor: {
          primary: "#FB6D3B",
          text_toolbar_color: "#FB6D3B",
          text_color: "#FB6D3B",
          button_color: "#FB6D3B",
        },
        price: null,
        primary: "#FB6D3B",
        logo: null,
        logo_mob_header: null,
        logo_mob_footer: null,
        logo_mob_restoran: null,
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        order_before: 0,
        header: null,
        restoran_image: null,
        izvestaj: false,
        ijekavica: false,
        ekavica: false,
        rok_dana: true,
        rok_sati: false,
        broj_sati: "",
        dan: "",
        worker: true,
        can_reserve: false,
        delivery_from_hour: "",
        delivery_from_min: "00",
        delivery_to_hour: "",
        delivery_to_min: "00",
      },
      alphabet: "",
      lang: "",
      lat: "",
      cir: "",
      hrv: "",
      vreme: moment().format("HH:mm"),

      gallery: false,
      images: [],
      selectedMenu: null,
      searchImage: null,
    };
  },
  computed: {
    days() {
      return [
        { text: this.$t("monday"), val: 1 },
        { text: this.$t("tuesday"), val: 2 },
        { text: this.$t("wednesday"), val: 3 },
        { text: this.$t("thursday"), val: 4 },
        { text: this.$t("friday"), val: 5 },
        { text: this.$t("saturday"), val: 6 },
        { text: this.$t("sunday"), val: 7 },
      ];
    },
    weekDays() {
      return [
        { key: "monday", label: this.$t("monday") },
        { key: "tuesday", label: this.$t("tuesday") },
        { key: "wednesday", label: this.$t("wednesday") },
        { key: "thursday", label: this.$t("thursday") },
        { key: "friday", label: this.$t("friday") },
        { key: "saturday", label: this.$t("saturday") },
        { key: "sunday", label: this.$t("sunday") },
      ];
    },
  },
  watch: {
    "settings.mobColor.primary": {
      handler: function (val, oldVal) {
        this.settings.mob.primary = val ? val.hex : null;
      },
      deep: true,
    },
    "settings.mobColor.text_toolbar_color": {
      handler: function (val, oldVal) {
        this.settings.mob.text_toolbar_color = val ? val.hex : null;
      },
      deep: true,
    },
    "settings.mobColor.text_color": {
      handler: function (val, oldVal) {
        this.settings.mob.text_color = val ? val.hex : null;
      },
      deep: true,
    },
    "settings.mobColor.button_color": {
      handler: function (val, oldVal) {
        this.settings.mob.button_color = val ? val.hex : null;
      },
      deep: true,
    },
  },

  created() {
    if (this.$store.state && this.$store.state.restaurant) {
      this.settings = {
        ...this.settings,
        ...this.$store.state.restaurant.settings,
      };

      if (this.$store.state.restaurant.lang == "ekavica") {
        this.$set(this.settings, "ekavica", true);
        this.$set(this.settings, "ijekavica", false);
      } else if (this.$store.state.restaurant.lang == "ijekavica") {
        this.$set(this.settings, "ijekavica", true);
        this.$set(this.settings, "ekavica", false);
      }
      if (this.$store.state.restaurant.alphabet == "cir") {
        this.alphabet = "cir";
        this.cir = this.$store.state.restaurant.alphabet;
      }
      if (this.$store.state.restaurant.alphabet == "lat") {
        this.alphabet = "lat";
        this.lat = this.$store.state.restaurant.alphabet;
      }
    }

    this.getImage();
  },
  methods: {
    switchTimeStatus(type) {
      if (type == "old") {
        this.settings.old_time_changes = true;
        this.settings.new_time_changes = false;
      }
      if (type == "new") {
        this.settings.old_time_changes = false;
        this.settings.new_time_changes = true;
      }
    },
    setDelivery() {},
    switchHours() {
      if (this.settings.rok_sati) {
        this.settings.rok_dana = false;
      }
      if (!this.settings.rok_sati) {
        this.settings.rok_dana = true;
      }
    },
    switchDays() {
      if (this.settings.rok_dana) {
        this.settings.rok_sati = false;
      }
      if (!this.settings.rok_dana) {
        this.settings.rok_sati = true;
      }
    },
    switchHoursGuest() {
      if (this.settings.guest.rok_sati) {
        this.settings.guest.rok_dana = false;
      }
      if (!this.settings.guest.rok_sati) {
        this.settings.guest.rok_dana = true;
      }
    },
    switchDaysGuest() {
      if (this.settings.guest.rok_dana) {
        this.settings.guest.rok_sati = false;
      }
      if (!this.settings.guest.rok_dana) {
        this.settings.guest.rok_sati = true;
      }
    },
    async changeDialekt(dialekt) {
      if (dialekt == "ekavica") {
        this.settings.ekavica = true;
        this.settings.ijekavica = false;
      }
      if (dialekt == "ijekavica") {
        this.settings.ekavica = false;
        this.settings.ijekavica = true;
      }
      try {
        await restaurantService.updateRestaurantLanguage(
          this.$store.state.restaurant.id,
          dialekt
        );
        this.showSuccessSnackbar(this.$t("language_updated_successfully"));
        window.location.reload();
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_updating_language"));
      }
    },
    async changeLang() {
      if (this.alphabet == "cir") {
        this.cir = true;
        this.lat = false;
      } else if (this.alphabet == "lat") {
        this.lat = true;
        this.cir = false;
      }

      try {
        const res = await restaurantService.updateRestaurantTextLanguage(
          this.$store.state.restaurant.id,
          {
            lat: this.lat,
            cir: this.cir,
            hrv: this.hrv,
            alphabet: this.alphabet,
          }
        );
        this.$root.$emit("langChanged", res);
        this.showSuccessSnackbar(this.$t("alphabet_updated_successfully"));
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_updating_alphabet"));
      }
      this.$forceUpdate();
    },
    filterImage() {
      this.imagesFilter = this.images.filter((i) => i.name.includes(this.searchImage));
    },
    save() {
      restaurantService
        .updateRestaurantSettings(this.$store.state.restaurant.id, this.settings)
        .then((res) => {
          location.reload();
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_saving_settings"));
        });
    },
    getImage() {
      menuService
        .getGalleryImages()
        .then((res) => {
          this.images = res.data;
          this.imagesFilter = res.data;
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_loading_images"));
        });
    },
    removeImageConfirm(imageType) {
      const imageTypeNames = {
        logo: this.$t("logo"),
        header: this.$t("header"),
        restoran_image: this.$t("restaurant_image"),
        logo_mob_header: this.$t("mobile_header_banner"),
        logo_mob_footer: this.$t("mobile_footer_banner"),
        logo_mob_restoran: this.$t("mobile_restaurant_image"),
      };

      this.$refs.confirmBox
        .open(
          this.$t("remove_image"),
          this.$t("remove_branding_confirmation", { type: imageTypeNames[imageType] }),
          { color: "warning" }
        )
        .then(() => {
          this.settings[imageType] = null;
          this.showSuccessSnackbar(this.$t("image_removed"));
        })
        .catch(() => {
          // User cancelled
        });
    },
    selectImage(image) {
      this.gallery = false;
      if (this.changeHeader) {
        this.settings.header = image.name;
        this.changeHeader = 0;
      }
      if (this.changeRestoran) {
        this.settings.restoran_image = image.name;
        this.changeRestoran = 0;
      }
      if (this.changeLogo) {
        this.settings.logo = image.name;
        this.changeLogo = 0;
      }
      if (this.changeLogoMob) {
        this.settings.logo_mob_header = image.name;
        this.changeLogoMob = 0;
      }
      if (this.changeLogoMobFooter) {
        this.settings.logo_mob_footer = image.name;
        this.changeLogoMobFooter = 0;
      }
      if (this.changeLogoMobRestoran) {
        this.settings.logo_mob_restoran = image.name;
        this.changeLogoMobRestoran = 0;
      }
    },
  },
  filters: {
    imageName(name) {
      if (name) {
        let imageName = name.split(".");
        return imageName[0].replace("_", " ").replace("-", " ");
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

label.primary-bg-light {
  display: block;
  height: 100%;
  line-height: 4.3;
  margin-right: 5px;
}
.primary-bg-light {
  background: $primary-light !important;
  border-radius: 5px !important;
}

// Typography classes
.heading-large {
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 0;
}

.heading-medium {
  font-weight: 700;
  font-size: 25px;
  margin-bottom: 0;
}

.heading-small {
  font-weight: 700;
  font-size: 19px;
}

.heading-extra-small {
  font-weight: 700;
  font-size: 14px;
}

.text-tiny {
  font-size: 10px;
  padding-top: 22px;
}

// Layout helpers
.centered-text {
  text-align: center;
}

.flex-center {
  display: flex;
  align-items: center;
}

.delivery-description {
  width: 65%;
  margin-left: 15px;
}

.post-delivery-description {
  width: 100%;
  margin-left: 15px;
}

#slanje-postom {
  margin-top: 0;
  width: 32%;
}
#restoran-obavlja-isporuku {
  width: 32%;
}
#vreme-za-narudzbe {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 0;
}
.theme--light.v-image {
  height: 120px !important;
}
.image-width {
  width: 220px;
  height: 120px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
// Time settings row responsive
.time-settings-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

// Mobile optimization
@media (max-width: 959px) {
  // Switch full width on tablet
  #slanje-postom,
  #restoran-obavlja-isporuku {
    width: 100%;
  }

  .image-width {
    width: 100%;
    height: auto;
    min-height: 120px;
  }

  .okolo {
    display: block;
  }

  // Stack time settings vertically on tablet
  .time-settings-row {
    .v-col {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  // Vremenska podesavanja - tablet prikaz
  .day-settings-row {
    .v-col[style*="max-width: 2.3%"] {
      display: none;
    }

    // Poboljšanje margina
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  // Card-like appearance za sekcije
  .mb-8 {
    padding-left: 8px;
    padding-right: 8px;
  }
}

@media (max-width: 600px) {
  // Minimal mobile fixes - don't break existing layout

  // Image upload sections
  .image-width {
    margin-bottom: 16px;
  }

  // Make buttons touch-friendly
  button {
    min-height: 44px !important;
  }

  // Globalno uklanjanje label height-a na mobilnom
  label.primary-bg-light {
    height: auto !important;
  }

  // Naslovi sekcija - konzistentan stil
  .v-col > div[style*="font-size"] {
    font-size: 15px !important;
    font-weight: 600 !important;
    color: #424242 !important;
    padding: 0 0 8px 0 !important;
    margin-bottom: 12px !important;
    border-bottom: 1px solid #e0e0e0 !important;
  }

  // Vremenska podesavanja - mobilni prikaz (svi dani)
  .day-settings-row {
    flex-direction: column;
    border: none !important;
    padding: 20px 12px;
    background: #fafafa;
    border-radius: 8px;
    margin-bottom: 20px !important;

    > .v-col {
      max-width: 100% !important;
      padding: 16px 12px !important;
      margin-bottom: 20px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

      &:first-child {
        background: transparent;
        box-shadow: none;
        padding: 0 !important;
        margin-bottom: 20px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      // Naslov sekcije
      > div:first-child {
        font-weight: 600 !important;
        margin-bottom: 12px !important;
        padding-bottom: 8px !important;
        color: #424242;
        font-size: 15px !important;
        border-bottom: 1px solid #e0e0e0;
      }
    }

    // Sakrij strelice < > na mobilnom
    .v-col[style*="max-width: 2.3%"] {
      display: none !important;
    }

    // Dan labela - kao heading
    > .v-col:first-child {
      label.primary-bg-light {
        font-size: 17px;
        font-weight: 700;
        display: block;
        text-align: center;
        padding: 12px;
      }
    }

    // Reset inner nested elements da ne kvare layout
    .grey.lighten-4,
    .position-relative,
    .primary-bg-light:not(label) {
      background: transparent !important;
      border: none !important;
      padding: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }

    // Input grid layout
    .v-row {
      margin: 0 !important;

      > .v-col {
        padding: 0 !important;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }

        > .v-row {
          margin: 0 -4px !important;

          > .v-col {
            padding: 0 4px !important;
          }
        }
      }
    }
    > .v-col.primary-bg-light {
      background: rgba(251, 109, 59, 0.1) !important;
    }
  }

  // Heading font size adjustments
  .heading-small {
    font-size: 16px;
  }

  .heading-medium {
    font-size: 20px;
  }

  .heading-large {
    font-size: 22px;
  }

  // Delivery description sections
  .delivery-description,
  .post-delivery-description {
    width: 100%;
    margin-left: 0;
  }
}
</style>
<style>
.velicina-labele .v-label {
  font-size: 13px !important;
}
</style>
